module.exports = __webpack_public_path__ + "img/left-gray.16fb2449.svg";